import React from 'react'
import NavbarComponent from '../landingPageComponent/Navbar'

const CustomizeAdminPortal = () => {
  return (
    <>
      <NavbarComponent pricing={false} login={false} signup={false} user={false}  />
    </>
  )
}

export default CustomizeAdminPortal